import axios from 'axios';
import { Dispatch } from 'react';
import { GET_SIGNUP_REQUEST, GET_SIGNUP_SUCCESS, GET_SIGNUP_FAILURE, RESET_VALIDATION_MESSAGE } from '../constants/signup.constant';
import { AnyIfEmpty } from 'react-redux';
import { verifyInvitation } from '../../invited-staff/actions/invitedStaff.actions';
import { noPermissionsAssigned } from '../../setInitialPermission/actions/setInitialPermission.action';

const getSignupRequest = () => {
    return {
        type: GET_SIGNUP_REQUEST,
    };
};

const getSignupSuccess = (signupData: AnyIfEmpty<object>) => {
    return {
        type: GET_SIGNUP_SUCCESS,
        payload: signupData,
    };
};

const getSignupFailure = (signupError: string) => {
    return {
        type: GET_SIGNUP_FAILURE,
        payload: signupError,
    };
};

export const resetValidationMessage = () => {
    return {
        type: RESET_VALIDATION_MESSAGE,
    };
};

export const getRegister = (signupDetails: AnyIfEmpty<object>, onSuccess: AnyIfEmpty<object>, locationId?: string, invitedAdminId?: string) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getSignupRequest());
        return await axios.post(`/admin/register`, signupDetails)
            .then(async (response) => {
                if (response.data.statusCode === 201) {
                    dispatch(getSignupSuccess(response.data.result));
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    localStorage.setItem('adminAccessToken', response.data.token);
                    localStorage.setItem('email', signupDetails.email);
                    dispatch(noPermissionsAssigned())
                    await onSuccess();
                } else {
                    dispatch(getSignupFailure(response.data.message));
                }
            })
            .catch((error) => dispatch(getSignupFailure(error.response.data.message[0])));
    };
};
